import { CircularProgress } from '@mui/material';
import React from 'react';

export default function Loader() {
    return (
        <div style={{ width: '95vw', height: '60vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <CircularProgress size={35} color="inherit" />
        </div>
    );
}
